import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ca-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  standalone: false,
})
export class AvatarComponent {
  private _fullName;
  private _image;

  @HostBinding('class.border')
  @Input()
  border: boolean = false;
  @Input()
  initials: string;
  @Input()
  set fullName(data: string) {
    this._fullName = data;
    if (!data) {
      this.initials = '';
    } else {
      this.initials = data
        .replace(/[^0-9a-z ]/gi, '')
        .split(' ')
        .map((name) => name.charAt(0))
        .join('');
    }
  }
  get fullName() {
    // Allows for testability in other components
    return this._fullName;
  }

  @Input()
  background: boolean;
  @Input()
  set image(data: string) {
    this._image = data;
  }

  get image() {
    return this._image;
  }

  @Input()
  blur: string;

  @Input()
  small: boolean;

  @Input()
  chip: boolean;

  @Input() fontSize?: number;
}
